export default "__VITE_ASSET__CgWftsfv__"